import ResizeItemCommand from '../command/resizeItemCommand';
import TablelegItem from '../item/tablelegItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class HeightField
 */
export default class HeightField extends LengthUnitField {
    type = 'height';
    supports = 'supportsHeight';

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.get('height'));
    }

    /**
     * Update item with field value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const width = item.get('width');
        const height = this.getValue();
        const position = item.get('position').clone();
        const history = this.editor.getCanvas().getHistory();

        this.assertItemValue(item, 'height', height);

        const command = new ResizeItemCommand(item, width, height, position);

        history.addAndExecuteCommand(command);
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     *
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const width = item.get('width');
        const height = this.getValue() + difference;
        const position = item.get('position').clone();
        const history = this.editor.getCanvas().getHistory();

        this.assertItemValue(item, 'height', height);

        const command = new ResizeItemCommand(item, width, height, position);

        history.addAndExecuteCommand(command);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        const supportFlag = this.supports;

        return selectionLength === 1
            && supportFlag
            && item
            && item[supportFlag]
            && !(item instanceof TablelegItem);
    }
}
